import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { SearchProFunnelModel } from "../../../model/builk/profunnel/search-profunnel.model";
import { ProFunnelListModel } from "../../../model/builk/profunnel/profunnel-list.model";
import { apiLink } from "../../../constant/api-link";
import { ProFunnelModel } from "../../../model/builk/profunnel/profunnel.model";
import { BadgeModel } from "../../../model/builk/profunnel/profunnel-badge.model";
import { BadgeListModel } from "../../../model/builk/profunnel/profunnel-badge-list.model";
import { PublicCompanyDetailModel } from "../../../model/builk/profunnel/publiccompany-detail.model";
import { ProfunnelInfo } from "../../../model/builk/profunnel/profunnel-info.model";

@Injectable({
    providedIn: "root"
})
export class ProFunnelService {

    constructor(
        private http: HttpClient
    ) { }

    sub: any;

    // get userlist (sort,search,filter)
    getProFunnelBackOffice(searchProFunnelModel: SearchProFunnelModel): Observable<ProFunnelListModel> {

        const url = apiLink.getProFunnelBackOffice;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.post<ProFunnelListModel>(url, searchProFunnelModel, { headers });
    }

    updateProFunnelBackOffice(proFunnel: ProFunnelModel): Observable<ProFunnelModel> {
        const url = apiLink.updateProFunnelBackOffice;

        const headers = new HttpHeaders({ "Content-Type": "text/json" });

        return this.http.put<ProFunnelModel>(url, proFunnel, { headers });
    }

    updateCommentProFunnelBackOffice(proFunnel: ProFunnelModel): Observable<boolean> {
        const url = apiLink.updateCommentProFunnelBackOffice;

        const headers = new HttpHeaders({ "Content-Type": "text/json" });

        return this.http.put<boolean>(url, proFunnel, { headers });
    }

    getBadgeByIdBackOffice(companySurrKey: number): Observable<Array<number>> {
        const url = apiLink.getBadgeByIdBackOffice;
        const params = new HttpParams().set("companySurrKey", companySurrKey.toString());
        this.sub = this.http.get(url, { params });

        return this.sub;
    }

    getListBadgeBackOffice(): Observable<Array<BadgeModel>> {
        const url = apiLink.getListBadgeBackOffice;
        this.sub = this.http.get(url);

        return this.sub;
    }

    updateBadgeBackOffice(badgeList: BadgeListModel): Observable<boolean> {
        const url = apiLink.updateBadgeBackOffice;

        const headers = new HttpHeaders({ "Content-Type": "text/json" });

        return this.http.put<boolean>(url, badgeList, { headers });
    }

    getCompanyDetailByCompanySurrkey(companysurrkey: number): Observable<PublicCompanyDetailModel> {
        const url = apiLink.getPublicCompanyDetailByCompanySurrkey;
        const params = new HttpParams().set("companySurrKey", companysurrkey.toString());
        this.sub = this.http.get(url, { params });

        return this.sub;
    }
    updateHideCompanyBackOffice(companySurrKey: number, hideCompany: boolean): Observable<boolean> {
        const url = apiLink.updateHideCompanyBackOffice + `?companySurrkey=${companySurrKey}&isHideCompany=${hideCompany}`;
        return this.http.put<boolean>(url, {
            params: {
                companySurrkey: companySurrKey,
                hideCompany: hideCompany
            }
        });
    }

    getProFunnelInfo(country: string, culture: string, email: string): Observable<ProfunnelInfo> {
      const url = apiLink.getProFunnelInfo;
      const params = new HttpParams().set("Country", country).set('Culture', culture).set('Email', email);
      this.sub = this.http.get<ProfunnelInfo>(url, { params: params });
      return this.sub;
    }

    getCompanyCountries(): Observable<Array<string>> {
      const url = apiLink.getCountry;
      this.sub = this.http.get<ProfunnelInfo>(url);
      return this.sub;
    }

    getCompanyProject(companySurrKey: number): Observable<Array<any>> {
      const url = apiLink.getCompanyProjects + '?companySurrKey='+ companySurrKey +'&working=1&finished=0&pending=0&terminated=0';
      this.sub = this.http.get<Array<any>>(url);
      return this.sub;
    }

    exportProFunnelBackOffice(searchProFunnelModel: SearchProFunnelModel): Observable<Blob> {
      const url = apiLink.exportProFunnelBackOffice;
      
      let body = {
        sortCol: searchProFunnelModel.sortCol,
        sortType: searchProFunnelModel.sortType,
        culture: searchProFunnelModel.culture,
        email: searchProFunnelModel.email,
        searchCompanyId: searchProFunnelModel.searchCompanyId,
        searchCompanyName: searchProFunnelModel.searchCompanyName,
        searchCompanyState: searchProFunnelModel.searchCompanyState,
        searchCompanyType: searchProFunnelModel.searchCompanyType,
        searchCompanyCountry: searchProFunnelModel.searchCompanyCountry,
        searchHiddenCompany: searchProFunnelModel.searchHiddenCompany,
        searchCompanyUrl: searchProFunnelModel.searchCompanyUrl,
        searchCompanyGrade: searchProFunnelModel.searchCompanyGrade,
        searchContactName: searchProFunnelModel.searchContactName,
        searchEmail: searchProFunnelModel.searchEmail,
        searchPhone: searchProFunnelModel.searchPhone,
      };
      if (searchProFunnelModel.startDate !== undefined && searchProFunnelModel.startDate !== null) {
        body['startDate'] = searchProFunnelModel.startDate.toISOString();
      }

      if (searchProFunnelModel.endDate !== undefined && searchProFunnelModel.endDate !== null) {
        body['endDate'] = searchProFunnelModel.endDate.toISOString();
      }
      const headers = new HttpHeaders({ "Content-Type": "application/json" });
      return this.http.post<Blob>(url, body, { responseType: 'blob' as 'json', headers: headers });
    }
}
